// This file has been generated from LT.Web.App_Logic.SearchSetup.Models.SearchResultBaseVue

export default class SearchResultBaseVue {

    page: number;
    pageCount: number;
    pageSize: number;
    totalCount: number;
    hasResultsForParamsOnly: boolean;


	constructor(page: number, pageCount: number, pageSize: number, totalCount: number, hasResultsForParamsOnly: boolean){
	
        this.page = page;
        this.pageCount = pageCount;
        this.pageSize = pageSize;
        this.totalCount = totalCount;
        this.hasResultsForParamsOnly = hasResultsForParamsOnly;
	}
}